import { useGraphRef } from "components/shared/ReportComponents/TreatmentSummary/GraphRefContext";
import { GOAL_TRACK_PARAMETERS_COLORS } from "config/constants";
import { toPng } from "html-to-image";
import { cloneDeep } from "lodash";
import { forwardRef, useEffect, useImperativeHandle, useRef, useState } from "react";
import ReactApexChart from "react-apexcharts";

const LineGraph = forwardRef(({ dates, series }, ref) => {
// const LineGraph = ({ dates, series }) => {
  const chartRef = useRef(null);

  const [chartData, setChartData] = useState({
    series: [],
    options: {
      chart: {
        height: 350,
        type: "line",
        dropShadow: {
          enabled: true,
          color: "#000",
          top: 18,
          left: 7,
          blur: 10,
          opacity: 0.2,
        },
        zoom: {
          enabled: false,
        },
        toolbar: {
          show: false,
        },
      },
      dataLabels: {
        enabled: false, // Disable numbers on nodes
      },
      stroke: {
        curve: "smooth",
        width: 2, // Make the line thin
      },
      title: {
        // text: "Average High & Low Temperature",
        align: "left",
      },
      grid: {
        borderColor: "#e7e7e7",
        row: {
          colors: ["#f3f3f3", "transparent"],
          opacity: 0.5,
        },
      },
      markers: {
        size: 6, // Size of the node
        // colors: ["#FFF"], // Background color for the marker (node)
        // strokeColors: ["#77B6EA", "#545454"], // Border color of the marker
        strokeWidth: 2, // Border thickness of the marker
        // borderRadius: 50,
        hover: {
          size: 8, // Size when hovering over the marker
        },
      },
      xaxis: {
        categories: [],
        title: {
          //   text: "Month",
        },
      },
      yaxis: {
        title: {
          //   text: "Temperature",
        },
        // min: 1,
        // max: 10,
      },
      legend: {
        position: "top",
        horizontalAlign: "right",
        floating: true,
        offsetY: -25,
        offsetX: -5,
      },
    },
  });

  useEffect(() => {
    if(!dates || !series) {
      return;
    }

    const datesClone = cloneDeep(dates);
    const seriesClone = cloneDeep(series);

    const colors = seriesClone.map((item) => GOAL_TRACK_PARAMETERS_COLORS[item.name]);

    setChartData((prevState) => ({
      ...prevState,
      dates: datesClone,
      series: seriesClone,
      options: {
        ...prevState.options,
        colors,
        xaxis: {
          ...prevState.options.xaxis,
          categories: dates
        }
      }
    }))
  }, [dates, series])

  useImperativeHandle(ref, () => ({
    generateImage: async () => {
      if (chartRef.current) {
        try {
          const dataUrl = await toPng(chartRef.current, { pixelRatio: 2 });
          return dataUrl;
        } catch (error) {
          console.error("Error generating chart image", error);
        }
      }
    },
  }));

  return (
    <div>
      <div id="chart" ref={chartRef}>
        <ReactApexChart
          options={chartData.options}
          series={chartData.series}
          type="line"
          height={350}
        />
      </div>
      <div id="html-dist"></div>
    </div>
  );
});

export default LineGraph;